export class PoliceManifestationTraffic {
    get id() {
        return this.policeManifestationTrafficState.id;
    }
    get diligenceNumber() {
        return this.policeManifestationTrafficState.diligenceNumber;
    }
    get crowdedLocation() {
        return this.policeManifestationTrafficState.crowdedLocation;
    }
    get crowdedType() {
        return this.policeManifestationTrafficState.crowdedType;
    }
    get report() {
        return this.policeManifestationTrafficState.report;
    }
    get sketch() {
        return this.policeManifestationTrafficState.sketch;
    }
    get sketchExplanation() {
        return this.policeManifestationTrafficState.sketchExplanation;
    }
    get hourCommunicate() {
        return this.policeManifestationTrafficState.hourCommunicate;
    }
    get arrivalTime() {
        return this.policeManifestationTrafficState.arrivalTime;
    }
    get communicantThird() {
        return this.policeManifestationTrafficState.communicantThird;
    }
    get signaling() {
        return this.policeManifestationTrafficState.signaling;
    }
    get footprints() {
        return this.policeManifestationTrafficState.footprints;
    }
    get observations() {
        return this.policeManifestationTrafficState.observations;
    }
    get userId() {
        return this.policeManifestationTrafficState.userId;
    }
    get featuresVia() {
        return this.policeManifestationTrafficState.featuresVia;
    }
    get characteristicsDay() {
        return this.policeManifestationTrafficState.characteristicsDay;
    }
    get trafficAccident() {
        return this.policeManifestationTrafficState.trafficAccident;
    }
    get preventiveControl() {
        return this.policeManifestationTrafficState.preventiveControl;
    }
    get lostPoints() {
        return this.policeManifestationTrafficState.lostPoints;
    }
    get judicialDecision() {
        return this.policeManifestationTrafficState.judicialDecision;
    }
    get notPossessPermission() {
        return this.policeManifestationTrafficState.notPossessPermission;
    }
    get vehicleImmobilization() {
        return this.policeManifestationTrafficState.vehicleImmobilization;
    }
    get qualifiedPerson() {
        return this.policeManifestationTrafficState.qualifiedPerson;
    }
    get drivingAnomalies() {
        return this.policeManifestationTrafficState.drivingAnomalies;
    }
    get referralDate() {
        return this.policeManifestationTrafficState.referralDate;
    }
    get numFoliosRemision() {
        return this.policeManifestationTrafficState.numFoliosRemision;
    }
    get numMinutesRemision() {
        return this.policeManifestationTrafficState.numMinutesRemision;
    }
    get independentMinutes() {
        return this.policeManifestationTrafficState.independentMinutes;
    }
    get numcitations() {
        return this.policeManifestationTrafficState.numcitations;
    }
    get citations() {
        return this.policeManifestationTrafficState.citations;
    }
    get bodyTransfer() {
        return this.policeManifestationTrafficState.bodyTransfer;
    }
    get ethylmeterSeries() {
        return this.policeManifestationTrafficState.ethylmeterSeries;
    }
    get dateCheckEthilometer() {
        return this.policeManifestationTrafficState.dateCheckEthilometer;
    }
    set id(id) {
        this.policeManifestationTrafficState.id = id;
    }
    set crowdedLocation(crowdedLocation) {
        this.policeManifestationTrafficState.crowdedLocation = crowdedLocation;
    }
    set crowdedType(crowdedType) {
        this.policeManifestationTrafficState.crowdedType = crowdedType;
    }
    set report(report) {
        this.policeManifestationTrafficState.report = report;
    }
    set sketch(sketch) {
        this.policeManifestationTrafficState.sketch = sketch;
    }
    set sketchExplanation(sketchExplanation) {
        this.policeManifestationTrafficState.sketchExplanation = sketchExplanation;
    }
    set hourCommunicate(hourCommunicate) {
        this.policeManifestationTrafficState.hourCommunicate = hourCommunicate;
    }
    set arrivalTime(arrivalTime) {
        this.policeManifestationTrafficState.arrivalTime = arrivalTime;
    }
    set communicantThird(communicantThird) {
        this.policeManifestationTrafficState.communicantThird = communicantThird;
    }
    set signaling(signaling) {
        this.policeManifestationTrafficState.signaling = signaling;
    }
    set footprints(footprints) {
        this.policeManifestationTrafficState.footprints = footprints;
    }
    set observations(observations) {
        this.policeManifestationTrafficState.observations = observations;
    }
    set userId(userId) {
        this.policeManifestationTrafficState.userId = userId;
    }
    set featuresVia(featuresVia) {
        this.policeManifestationTrafficState.featuresVia = featuresVia;
    }
    set characteristicsDay(characteristicsDay) {
        this.policeManifestationTrafficState.characteristicsDay = characteristicsDay;
    }
    set trafficAccident(trafficAccident) {
        this.policeManifestationTrafficState.trafficAccident = trafficAccident;
    }
    set preventiveControl(preventiveControl) {
        this.policeManifestationTrafficState.preventiveControl = preventiveControl;
    }
    set lostPoints(lostPoints) {
        this.policeManifestationTrafficState.lostPoints = lostPoints;
    }
    set judicialDecision(judicialDecision) {
        this.policeManifestationTrafficState.judicialDecision = judicialDecision;
    }
    set notPossessPermission(notPossessPermission) {
        this.policeManifestationTrafficState.notPossessPermission = notPossessPermission;
    }
    set vehicleImmobilization(vehicleImmobilization) {
        this.policeManifestationTrafficState.vehicleImmobilization = vehicleImmobilization;
    }
    set qualifiedPerson(qualifiedPerson) {
        this.policeManifestationTrafficState.qualifiedPerson = qualifiedPerson;
    }
    set drivingAnomalies(drivingAnomalies) {
        this.policeManifestationTrafficState.drivingAnomalies = drivingAnomalies;
    }
    set referralDate(referralDate) {
        this.policeManifestationTrafficState.referralDate = referralDate;
    }
    set numFoliosRemision(numFoliosRemision) {
        this.policeManifestationTrafficState.numFoliosRemision = numFoliosRemision;
    }
    set numMinutesRemision(numMinutesRemision) {
        this.policeManifestationTrafficState.numMinutesRemision = numMinutesRemision;
    }
    set independentMinutes(independentMinutes) {
        this.policeManifestationTrafficState.independentMinutes = independentMinutes;
    }
    set numcitations(numcitations) {
        this.policeManifestationTrafficState.numcitations = numcitations;
    }
    set citations(citations) {
        this.policeManifestationTrafficState.citations = citations;
    }
    set bodyTransfer(bodyTransfer) {
        this.policeManifestationTrafficState.bodyTransfer = bodyTransfer;
    }
    set ethylmeterSeries(ethylmeterSeries) {
        this.policeManifestationTrafficState.ethylmeterSeries = ethylmeterSeries;
    }
    set dateCheckEthilometer(dateCheckEthilometer) {
        this.policeManifestationTrafficState.dateCheckEthilometer = dateCheckEthilometer;
    }
    constructor(policeManifestationTrafficState) {
        this.policeManifestationTrafficState = policeManifestationTrafficState;
    }
    getState() {
        return this.policeManifestationTrafficState;
    }
}
